import { c as _c } from "react/compiler-runtime";
import type { DropMetadata } from "@/entities/IDrop";
import CreateDropMetadataItem from "./CreateDropMetadataItem";
export default function CreateDropMetadataItems(t0) {
  const $ = _c(9);
  const {
    items,
    onMetadataRemove,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== disabled || $[1] !== items || $[2] !== onMetadataRemove) {
    let t3;
    if ($[4] !== disabled || $[5] !== onMetadataRemove) {
      t3 = item => <CreateDropMetadataItem key={item.data_key} item={item} onMetadataRemove={onMetadataRemove} disabled={disabled} />;
      $[4] = disabled;
      $[5] = onMetadataRemove;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = items.map(t3);
    $[0] = disabled;
    $[1] = items;
    $[2] = onMetadataRemove;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="tw-mb-3 tw-flex tw-flex-wrap tw-gap-x-2 tw-gap-y-2 lg:tw-mt-2">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}